import { JobSchedule, JobScheduleDetail } from 'types/job_schedule'
import { PaginationParameter } from '../common/pagination'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
const resource = 'job_schedules'
import { ApprovalStatus, RecruitingStatus } from 'types/job'
export type Status =
  | 'recruiting'
  | 'assigned'
  | 'unconfirmed'
  | 'worker_fee_update_request'
  | 'confirmed'
export const requests = {
  fetchJobSchedules: async (
    params?:
      | {
          job_id?: number
          approval_status?: ApprovalStatus
          recruiting_status?: RecruitingStatus
          status?: Status
        }
      | PaginationParameter,
  ) => {
    return await axiosForGigbaseBiz.get<DataResponse<JobSchedule[]>>(resource, {
      params,
    })
  },
  getItem: async (id: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<JobScheduleDetail>>(
      mergeURL(resource, id.toString()),
    )
  },
  confirm: async (id: number) => {
    return await axiosForGigbaseBiz.patch<DataResponse<JobSchedule>>(
      mergeURL(resource, id.toString(), 'confirm'),
    )
  },
  delete: async (id: number) => {
    return await axiosForGigbaseBiz.delete<DataResponse>(
      mergeURL(resource, id.toString()),
    )
  },
  cancelAssigned: async (id: number) => {
    return await axiosForGigbaseBiz.patch<DataResponse>(
      mergeURL(resource, id.toString(), 'cancel_assigned'),
    )
  },
}
